import { PaymentSchedule } from '../entities/db-stripe.model';

const getDefaultPaymentSchedule = (): PaymentSchedule => ({
  last_charge: 450,
  last_charge_currency: 'USD',
  last_charge_date: '2025-05-02T15:30:37.000Z',
  next_charge: 1530,
  next_charge_currency: 'USD',
  next_charge_date: '2026-04-30T15:19:39.000Z',
  plan_end_date: '2026-05-02T15:30:35Z',
  plan_start_date: '2025-05-02T15:30:35Z',
});

export const getPaymentSchedule = (
  paymentSchedule?: Partial<PaymentSchedule>,
): PaymentSchedule => ({
  ...getDefaultPaymentSchedule(),
  ...paymentSchedule,
});
